import { render, staticRenderFns } from "./LogsList.vue?vue&type=template&id=fc609120&scoped=true&"
import script from "./LogsList.vue?vue&type=script&lang=js&"
export * from "./LogsList.vue?vue&type=script&lang=js&"
import style0 from "./LogsList.vue?vue&type=style&index=0&id=fc609120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc609120",
  null
  
)

export default component.exports